import {StyleSheet} from "aphrodite";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";

import type {JsonPath} from "../../types.ts";

import ListItemNode from "./list-item-node.tsx";
import type {ListData} from "./types.ts";

const StyledUl = addStyle("ul");
const StyledOl = addStyle("ol");

export default function ListNode(props: {
    kind: ListData["kind"];
    items: ListData["items"];
    path: JsonPath;
}) {
    const {kind, items, path} = props;

    const Tag = kind === "numbered-list" ? StyledOl : StyledUl;
    const style = kind === "numbered-list" ? styles.ol : styles.ul;

    return (
        <Tag style={style}>
            {items.map((item, i) => (
                <ListItemNode
                    key={i}
                    item={item}
                    path={[...path, "items", `${i}`]}
                />
            ))}
        </Tag>
    );
}

const styles = StyleSheet.create({
    ul: {
        listStyle: "disc",
        marginInlineStart: sizing.size_240,
        display: "flex",
        flexDirection: "column",
        gap: sizing.size_120,
    },
    ol: {
        listStyle: "decimal",
        marginInlineStart: sizing.size_240,
        display: "flex",
        flexDirection: "column",
        gap: sizing.size_120,
    },
});
